export default "__VITE_ASSET__OUG6SGXE__"